import { ErrorBoundary } from '@features/errorBoundary';
import React from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';
import routes from './Routes';

const Router: React.FC<{}> = () => {
    const router = createBrowserRouter([
        {
            path: '/',
            element: (
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
            ),
            children: routes,
        },
    ]);

    return <RouterProvider router={router} />;
};

export default Router;
